// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"754":"01c941e6","1186":"789db5ca","4132":"b2820601","7718":"01c941e6","8068":"1f373a5c"}[chunkId] + ".chunk.css";
};